<template>
  <section class="section-header no__print" id="top">
    <div class="notify">
      <div class="container">
        <div class="notify__body">
          <span class="notify__heading">WORK TIME</span>
          <span class="notify__message">Open hours: 月曜〜金曜 9:00~19:00 (土･日･祝日休)</span>
        </div>
      </div>
    </div>

    <div class="header__navbar">
      <div class="container">
        <span class="header__navbar__tel">
          <a href="tel:+81363841395">03-6384-1395</a>
        </span>
        <a href="/" class="header__navbar__logo">
          <img v-lazy="logo" />
        </a>
        <div class="header__navbar__action">
          <a
            href="/checkout"
            class="header__navbar__cart"
            :class="{ 'has-item': cartNumber }"
            :data-count="cartNumber"
          ></a>
          <UserMenu v-if="currentUser" :user="currentUser" :pcOnly="true" class="header__navbar__profile__button"
            ></UserMenu>
          <div class="header__navbar__login" v-else>
            <LoginButton></LoginButton>
          </div>
        </div>
        <a class="header__navbar__menu" @click="menuOpen"></a>
      </div>
    </div>

    <div class="header__menus" :class="{ show: showMenu }">
      <div class="container">
        <div class="mobile-menu__header">
          <button class="mobile-menu__back" @click="submenuClose" :class="{ hide: showParent }"></button>
          <span class="mobile-menu__title">MENU</span>
          <button class="mobile-menu__close" @click="menuClose"></button>
        </div>
        <nav>
          <ul class="header__menu">
            <li class="header__menu__item" :class="{ active: isHomePage() }">
              <a href="/">ホーム</a>
            </li>
            <li
              class="header__menu__item has-dropdown"
              :class="{ selected: showDropdown[0], active: isActive('tagIds[]=47') }"
              @click="submenuOpen(0)"
            >
              <a href="/products?tagIds[]=47">胡蝶蘭</a>
              <div class="header__menu__dropdown">
                <div class="container">
                  <div
                    class="header__menu__dropdown__section flex-wrap"
                    :class="{ active: expanded[0][0] }"
                  >
                    <div class="header__menu__dropdown__section__header" @click="expand(0, 0)">目的で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus1.slice(0, 7)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus1.slice(7, 14)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[0][1] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(0, j)">予算で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byBudgetMenus1"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[0][2] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(0, 2)">色で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byColor1"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.name }}</a>
                      </li>
                    </ul>
                  </div>

                  <div class="header__menu__dropdown__section" :class="{ active: expanded[0][3] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(0, 3)">種類で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byKind1"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="header__menu__item has-dropdown"
              :class="{ selected: showDropdown[1], active: isActive('tagIds[]=48') }"
              @click="submenuOpen(1)"
            >
              <a href="/products?tagIds[]=48">観葉植物</a>
              <div class="header__menu__dropdown">
                <div class="container">
                  <div
                    class="header__menu__dropdown__section flex-wrap"
                    :class="{ active: expanded[1][0] }"
                  >
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 0)">目的で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus2.slice(0, 7)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus2.slice(7, 14)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][1] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 1)">予算で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byBudgetMenus2"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][2] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 2)">種類で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byKind2.slice(0, 3)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byKind2.slice(4, 7)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="header__menu__item has-dropdown"
              :class="{ selected: showDropdown[2], active: isActive('tagIds[]=49') }"
              @click="submenuOpen(2)"
            >
              <a href="/products?tagIds[]=49">スタンド花</a>
              <div class="header__menu__dropdown">
                <div class="container">
                  <div
                    class="header__menu__dropdown__section flex-wrap"
                    :class="{ active: expanded[1][0] }"
                  >
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 0)">目的で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus3.slice(0, 7)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus3.slice(7, 14)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][1] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 1)">予算で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byBudgetMenus3"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][2] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 2)">色で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byColor3"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.name }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][3] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 3)">種類で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byKind3"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="header__menu__item has-dropdown"
              :class="{ selected: showDropdown[3], active: isActive('tagIds[]=50') }"
              @click="submenuOpen(3)"
            >
              <a href="/products?tagIds[]=50">アレンジメント</a>
              <div class="header__menu__dropdown">
                <div class="container">
                  <div
                    class="header__menu__dropdown__section flex-wrap"
                    :class="{ active: expanded[1][0] }"
                  >
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 0)">目的で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus4.slice(0, 6)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byPurposeMenus4.slice(7, 13)"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][1] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 1)">予算で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byBudgetMenus4"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="header__menu__dropdown__section" :class="{ active: expanded[1][1] }">
                    <div class="header__menu__dropdown__section__header" @click="expand(1, 1)">色で探す</div>
                    <ul class="header__menu__dropdown__list">
                      <li
                        class="header__menu__dropdown__list__item"
                        v-for="menu in byColor4"
                        :key="menu.id"
                      >
                        <a :href="menu.url">{{ menu.name }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="header__menu__item header__menu__item__support has-dropdown"
              :class="{
                selected: showDropdown[4],
                active: isActiveSupportTab,
              }"
              @click="submenuOpen(4)"
            >
              <a>サポート</a>
              <div class="header__menu__dropdown">
                <div class="container">
                  <div class="header__menu__dropdown__section">
                    <a href="/guide">お買いガイド</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/faq">よくある質問</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/inquiries/new">お問い合わせ</a>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="header__menu__item header__menu__item__support has-dropdown mypage-menu-sp"
              :class="{ selected: showDropdown[5], active: (
                isActive('users') || 
                isActive('checkout') || 
                isActive('orders') ||
                isActive('orders/csv') ||
                isActive('receivers') ||
                isActive('senders') ||
                isActive('plates') ||
                isActive('invoices') ||
                isActive('alerts')
                )}"
              @click="submenuOpen(5)"
            >
              <a>マイページ</a>
              <div class="header__menu__dropdown">
                <div class="container">
                  <div class="header__menu__dropdown__section">
                    <a href="/users/edit">プロフィール</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/checkout">カート</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/orders">注文履歴</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/orders/csv">注文履歴CSVダウンロード</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/receivers">アドレス帳：お届け先</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/senders">アドレス帳：贈り主</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/plates">木札帳：木札</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/invoices">アドレス帳：請求書送付先</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href="/alerts">アラート</a>
                  </div>
                  <div class="header__menu__dropdown__section">
                    <a href @click.prevent="signOut">ログアウト</a>
                  </div>
                </div>
              </div>
            </li>
            <li class="header__menu__item mobile">
              <LoginButton :callback="loginOpen" v-if="!currentUser"></LoginButton>
              <UserMenu v-if="showParent && currentUser" :user="currentUser"></UserMenu>
            </li>
          </ul>
        </nav>
        <div class="mobile-menu__footer">
          <a class="mobile-menu__lang">日本語</a>
          <div class="mobile-menu__notify">
            <p>
              <b>Open hours:</b>
            </p>
            <p>Open hours: 月曜〜金曜 9:00~19:00 (土･日･祝日休)</p>
          </div>
          <div class="mobile-menu__notify">
            <p>
              <b>TEL:</b>
            </p>
            <p>
              <a href="tel:+81363841395">03-6384-1395</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("global");

import LoginButton from "./LoginButton";
import UserMenu from "./UserMenu";

import logo from "images/logo.png";

import HEADER_MENUS from "../constants/headerMenu";

export default {
  components: {
    LoginButton,
    UserMenu
  },
  props: {
    currentUser: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function() {
    return {
      logo: logo,
      showMenu: false,
      showDropdown: [false, false, false, false, false, false],
      showParent: true,
      expanded: [
        [false, false, false, false],
        [false, false, false]
      ],
      byPurposeMenus1: HEADER_MENUS.menu1.byPurpose,
      byBudgetMenus1: HEADER_MENUS.menu1.byBudget,
      byColor1: HEADER_MENUS.menu1.byColor,
      byKind1: HEADER_MENUS.menu1.byKind,
      byPurposeMenus2: HEADER_MENUS.menu2.byPurpose,
      byBudgetMenus2: HEADER_MENUS.menu2.byBudget,
      byKind2: HEADER_MENUS.menu2.byKind,
      byPurposeMenus3: HEADER_MENUS.menu3.byPurpose,
      byBudgetMenus3: HEADER_MENUS.menu3.byBudget,
      byColor3: HEADER_MENUS.menu3.byColor,
      byKind3: HEADER_MENUS.menu3.byKind,
      byPurposeMenus4: HEADER_MENUS.menu4.byPurpose,
      byBudgetMenus4: HEADER_MENUS.menu4.byBudget,
      byColor4: HEADER_MENUS.menu4.byColor
    };
  },
  computed: {
    ...mapState(["cartNumber"]),
    isActiveSupportTab() {
      const subMenuPaths = [
        "guide",
        "faq",
        "inquiries",
        "inquiry_pot_collections",
      ];

      return subMenuPaths.some(
        (path) => window.location.pathname.indexOf(path) !== -1
      );
    },
  },
  created: function() {
    this.fetchCartNumber();
  },
  methods: {
    ...mapActions(["updateCartNumber"]),
    fetchCartNumber: async function() {
      if (window.location.href.indexOf("checkout") != -1) {
        return;
      }

      const res = await this.$axios.get("/carts/cart_number");

      this.updateCartNumber(res.data);
    },
    menuOpen: function() {
      this.showMenu = true;
    },
    menuClose: function() {
      this.showMenu = false;
      this.submenuClose();
    },
    submenuOpen: function(index) {
      this.showParent = false;
      this.showDropdown.forEach((e, i) => {
        if (i === index) {
          this.showDropdown[i] = true;
        } else {
          this.showDropdown[i] = false;
        }
      });
    },
    submenuClose: function() {
      this.showParent = true;
      this.showDropdown.forEach((e, i) => {
        this.showDropdown[i] = false;
      });
    },
    expand: function(menuId, sectionId) {
      this.$set(
        this.expanded[menuId],
        sectionId,
        !this.expanded[menuId][sectionId]
      );
    },
    loginOpen: function() {
      this.menuClose();
    },
    isActive: function(path) {
      return window.location.href.indexOf(path) !== -1;
    },
    isHomePage: function() {
      return window.location.pathname === "/";
    },
    signOut: async function() {
      await this.$axios.delete("/users/sign_out", {
        data: {
          authenticity_token: document.querySelector("meta[name=csrf-token]")
            .content
        }
      });

      this.$toasted.success("ログアウトされました。", {
        duration: 500,
        theme: "bubble",
        onComplete: () => {
          window.location.replace("/");
        }
      });
    }
  }
};
</script>
<style scoped>
.header__navbar__tel > a {
  color: black !important;
}

.mobile-menu__notify > p > a {
  color: black !important;
}
</style>
